import * as React from 'react';
import { useTranslation } from 'react-i18next';
import CircularProgress from '@mui/material/CircularProgress';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import * as Device from 'react-device-detect';

import { useListHomeSpotsLazyQuery, ListHomeSpotsQuery } from '@graphql';
import { EVENTS_SPOTS_CACHE_TTL, SPOTS_LAST_CALL } from '@utils';
import { useElementHeight } from '@hooks';
import { Sliders, Highlight } from '@components';

const SpotsPage = () => {
  const [homeSpots, setHomeSpots] = React.useState<ListHomeSpotsQuery['homeSpots'] | null>(null);
  const [highlightReady, setHighlightReady] = React.useState(Device.isDesktop);
  const bottomNavHeight = useElementHeight({ selector: '#bottomnav' });
  const { t } = useTranslation('spot');

  const getLastCallFromStorage = () => {
    const storedLastCall = localStorage.getItem(SPOTS_LAST_CALL);
    return storedLastCall ? parseInt(storedLastCall, 10) : new Date().getTime();
  };
  const [lastCall, setLastCall] = React.useState<number>(getLastCallFromStorage());

  const [getSpots] = useListHomeSpotsLazyQuery({
    fetchPolicy: 'cache-and-network',
  });

  React.useEffect(() => {
    const now = new Date().getTime();
    const timeSinceLastCall = now - lastCall;

    if (!homeSpots || timeSinceLastCall > EVENTS_SPOTS_CACHE_TTL) {
      getSpots().then(({ data }) => {
        setHomeSpots(data?.homeSpots ?? null);
        const now = new Date().getTime();
        setLastCall(now);
        localStorage.setItem(SPOTS_LAST_CALL, now.toString());
      });
    }
  }, [homeSpots, lastCall]);

  return (
    <Stack pb={2} pt={Device.isMobile ? 2 : undefined}>
      <Highlight type="spot" setHighlightReady={setHighlightReady} />
      {highlightReady ? (
        <Sliders
          categories={(homeSpots ?? []).reduce(
            (categories, category) => {
              if (category.spots.length) {
                categories.push({ ...category, title: t(`homeCategories.${category.title}`) });
              }
              return categories;
            },
            [] as ListHomeSpotsQuery['homeSpots']
          )}
        />
      ) : (
        <CircularProgress
          color="uncolored"
          sx={{
            position: 'absolute',
            bottom: '13%',
            left: '45%',
            transform: 'translate(-50%, -50%)',
          }}
        />
      )}
    </Stack>
  );
};

export default SpotsPage;
